import AxiosService from '../rest/AxiosService'

class BGTaskRestService {
    get(configId: number): Promise<any> {
        return AxiosService.get('/backgroundtasks?configId=' + configId)
    }

    getById(id: number): Promise<any> {
        return AxiosService.get('/backgroundtasks/' + id)
    }

    create(scheduleId: number): Promise<any> {
        return AxiosService.post('/backgroundtasks/schedule/' + scheduleId)
    }

    cancel(scheduleId: number): Promise<any> {
        return AxiosService.put('/backgroundtasks/schedule/' + scheduleId)
    }
}
export default new BGTaskRestService()
